var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDirectional(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.56152 6.86393C3.56152 7.03452 3.6278 7.20529 3.75814 7.33529L3.81543 7.39258C4.0761 7.65324 4.49814 7.65324 4.75814 7.39258L7.33366 4.81706L7.33366 13.5306C7.33366 13.8986 7.63232 14.1973 8.00032 14.1973C8.36832 14.1973 8.66699 13.8986 8.66699 13.5306L8.66699 4.81706L11.2425 7.39258C11.5032 7.65324 11.9252 7.65324 12.1852 7.39258L12.2425 7.33529C12.5032 7.07462 12.5032 6.65258 12.2425 6.39258L8.47168 2.62174C8.21101 2.36108 7.78897 2.36108 7.52897 2.62174L3.75814 6.39258C3.6278 6.52291 3.56152 6.69335 3.56152 6.86393Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirectional);
export default __webpack_public_path__ + "static/media/Directional.62ea9294925d70a05bc466ec19179327.svg";
export { ForwardRef as ReactComponent };